import { render, staticRenderFns } from "./ProfileLikeIcon.vue?vue&type=template&id=4af2d045&scoped=true"
import script from "./ProfileLikeIcon.vue?vue&type=script&lang=ts"
export * from "./ProfileLikeIcon.vue?vue&type=script&lang=ts"
import style0 from "./ProfileLikeIcon.vue?vue&type=style&index=0&id=4af2d045&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af2d045",
  null
  
)

export default component.exports